const state = {
  startDate: null,
  endDate: null,
  location: null,
  user: null,
};

const getters = {
  getStartDate(state) {
    return state.startDate;
  },
  getEndDate(state) {
    return state.endDate;
  },
  getLocation(state) {
    return state.location;
  },
  getUser(state) {
    return state.user;
  }
};

const mutations = {
  setRangeDate(state, {start, end}) {
    state.endDate = end;
    state.startDate = start;
  },
  setLocation(state, location) {
    state.location = location;
  },
  setUser(state, user) {
    state.user = user;
  },
}

export default {
  state,
  getters,
  mutations,
};